import { render, staticRenderFns } from "./StatusesSpan.vue?vue&type=template&id=2567b8df&"
import script from "./StatusesSpan.vue?vue&type=script&lang=js&"
export * from "./StatusesSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports